const pieColorsDE = {
    inaktiv: '#808080',
    aktiv: '#004d00',
    abgeschlossen: '#33cc33',
    abgesagt: '#cc0000',
};

export default pieColorsDE;
